<nav class="navbar fixed-top navbar-expand-xl py-0 border-bottom border-2 navbar-env-border" [ngClass]="{'navbar-env-border--local': appInfo['environment'] === 'local', 'navbar-env-border--testing': appInfo['environment'] === 'testing', 'navbar-env-border--staging': appInfo['environment'] === 'staging'}">
    <div class="container-fluid">
        <div class="navbar-brand">
            <a routerLink="/">
                <app-hexagon-logo size="sm"></app-hexagon-logo>
                <span class="navbar-brand-text">Hexagon</span>
            </a>
            <a href="{{ appInfo['build_url'] }}" target="_blank" class="badge env-badge d-none d-xl-inline-block"
                  [ngClass]="{'env-badge--local': appInfo['environment'] === 'local', 'env-badge--testing': appInfo['environment'] === 'testing', 'env-badge--staging': appInfo['environment'] === 'staging'}"
                  *ngIf="appInfo['environment'] && appInfo['environment'] !== 'production'">
                {{ appInfo['environment'] }}
            </a>
            <a href="{{ latestVersionInfo ? latestVersionInfo.versionUrl : appInfo['version_url'] }}" target="_blank" class="badge env-badge"
               [ngClass]="{'env-badge--local': appInfo['environment'] === 'local', 'env-badge--testing': appInfo['environment'] === 'testing', 'env-badge--staging': appInfo['environment'] === 'staging', 'env-badge--prod': appInfo['environment'] === 'production'}"
               [ngbTooltip]="latestVersionInfo ? 'A new version is available — click to refresh' : null"
               (click)="onVersionBadgeClick($event)"
               *ngIf="appInfo['version']">
                <ng-container *ngIf="!latestVersionInfo">{{ appInfo['version'] }}</ng-container>
                <ng-container *ngIf="latestVersionInfo">{{ appInfo['version'] }} &rarr; {{ latestVersionInfo.version }}</ng-container>
            </a>
        </div>
        <div class="d-flex d-xl-none align-items-center gap-2">
            <div class="dropdown" *ngIf="user">
                <a href="javascript:void(0)" class="d-block text-gray-700 text-decoration-none dropdown-toggle" id="dropdownUser1Mobile" data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarUserDropdownMobile">
                    <app-admin-avatar [isAdmin]="user.is_admin" size="sm" [centered]="true">
                        <img src="{{ user['pic-internal'] }}" *ngIf="hasProfilePic()" (error)="handleImageError()" alt="mdo" width="32" height="32" class="rounded-circle avatar-photo">
                        <span *ngIf="!hasProfilePic()" class="user-avatar-initials user-avatar-initials--sm">{{ getUserInitials(user.first_name + ' ' + user.last_name) }}</span>
                    </app-admin-avatar>
                </a>
                <ul class="dropdown-menu dropdown-menu-end user-dropdown-menu" aria-labelledby="dropdownUser1Mobile">
                    <li><h6 class="dropdown-header">{{ user.first_name }} {{ user.last_name }}</h6></li>
                    <li><a class="dropdown-item" routerLink="/users/{{ user.id }}" data-qa="navbarUserProfile">My profile</a></li>
                    <li><a class="dropdown-item" routerLink="/users/{{ user.id }}/entities" data-qa="navbarUserEmailSignature">Email signature</a></li>
                    <li><a class="dropdown-item" routerLink="/users/{{ user.id }}/wordpress" data-qa="navbarUserWordPress">WordPress</a></li>
                    <li><hr class="dropdown-divider bg-secondary"></li>
                    <li>
                        <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:void(0)" (click)="switchThemeMode(); $event.stopPropagation()" data-qa="navbarUserThemeMode">
                            <span>Mode</span>
                            <span class="theme-switch" [class.theme-switch--light]="getThemeMode() === 'light'">
                                <i class="fa fa-fw fa-sun"></i>
                                <span class="theme-switch__track">
                                    <span class="theme-switch__thumb"></span>
                                </span>
                                <i class="fa fa-fw fa-moon"></i>
                            </span>
                        </a>
                    </li>
                    <li><hr class="dropdown-divider bg-secondary"></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()" data-qa="navbarUserLogout">Logout</a></li>
                </ul>
            </div>
            <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarOffcanvas"
                aria-controls="navbarOffcanvas" aria-expanded="false" aria-label="Toggle navigation" data-qa="navbarToggleBtn">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>
        <div class="offcanvas offcanvas-end offcanvas-xl" tabindex="-1" id="navbarOffcanvas" aria-labelledby="navbarOffcanvasLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="navbarOffcanvasLabel">Menu</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item dropdown" routerLinkActive #salesActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="salesActive.isActive" href="javascript:void(0)" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarSalesDropdown">
                        <i class="fas fa-euro-sign"></i>
                        Sales
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/golinks" data-qa="navbarSalesGolinks">
                                <i class="fas fa-fw fa-link"></i>
                                Go-links
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/campaigns" data-qa="navbarSalesCampaigns">
                                <i class="fas fa-fw fa-bucket"></i>
                                Campaigns
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/initiatives" data-qa="navbarSalesInitiatives">
                                <i class="fas fa-fw fa-lightbulb"></i>
                                Initiatives
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/xrt_codes" data-qa="navbarSalesXrtCodes">
                                <i class="fas fa-industry"></i>
                                XRT codes
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/partner_agreements" data-qa="navbarSalesPartnerAgreementsNew">
                                <i class="fa-solid fa-fw fa-handshake"></i>
                                Partner Agreements
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/commercial_leads" data-qa="navbarSalesCommercialLeads">
                                <i class="fas fa-bullseye"></i>
                                Commercial Leads
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/sales/streamers" data-qa="navbarSalesStreamers">
                                <i class="fas fa-fw fa-video"></i>
                                Streamers
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive #subAffActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="subAffActive.isActive" href="javascript:void(0)" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarSubAffiliationDropdown">
                        <i class="fa fa-handshake"></i>
                        Sub-Affiliation
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="mb-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/subaffiliation/publishers" data-qa="navbarSubAffiliationPublishers">
                                <i class="fa fa-address-card"></i>
                                Publishers
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/subaffiliation/publisher_groups" data-qa="navbarSubAffiliationPublisherGroups">
                                <i class="fa fa-people-group"></i>
                                Publisher Groups
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/subaffiliation/publisher_sites" data-qa="navbarSubAffiliationPublisherSites">
                                <i class="fa fa-globe"></i>
                                Publisher Sites
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/subaffiliation/campaigns" data-qa="navbarSubAffiliationCampaigns">
                                <i class="fa fa-bullhorn"></i>
                                Campaigns
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/subaffiliation/golinks" data-qa="navbarSubAffiliationGolinks">
                                <i class="fa fa-link"></i>
                                Go-Links
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive #cdbActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="cdbActive.isActive" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarCdbDropdown">
                        <i class="fas fa-briefcase"></i>
                        Cdb
                    </a>
                    <div id="CdbMenu" class="dropdown-menu" style="min-width:550px; overflow-x: hidden;">
                        <div class="row">
                            <div class="col-12 col-lg-auto">
                                <div class="list-group list-group-flush" aria-labelledby="navbarDropdown">
                                    <div class="dropdown-item">
                                        <h6 class="dropdown-header px-0">iGaming</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/authoritys" data-qa="navbarCdbAuthoritiesNew">
                                        <i class="fas fa-landmark"></i>
                                        Authorities
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/operator_licences" data-qa="navbarCdbLicences">
                                        <i class="fas fa-file-contract"></i>
                                        Licences
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/operators" data-qa="navbarCdbPartners">
                                        <i class="fas fa-fw fa-handshake"></i>
                                        Partners (Operators)
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/operator_brands" data-qa="navbarCdbBrands">
                                        <i class="fas fa-fw fa-bullseye"></i>
                                        Brands
                                    </a>
                                    <a class="dropdown-item" routerLinkActive="active" routerLink="/legal_companies" data-qa="navbarCdbLegalCompanies">
                                        <i class="fa-solid fa-city"></i>
                                        Legal Companies
                                    </a>
                                    <div class="dropdown-item">
                                        <h6 class="dropdown-header px-0">Legal &amp; Compliance</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/dmca-complaints" data-qa="navbarCdbDmcaComplaints">
                                        <i class="fa-solid fa-gavel"></i>
                                        DMCA Complaints
                                    </a>
                                    <a class="dropdown-item" routerLinkActive="active" routerLink="/google-takedowns" data-qa="navbarCdbGoogleTakedowns">
                                        <i class="fa-solid fa-shield-halved"></i>
                                        Google Takedowns
                                    </a>
                                    <div class="dropdown-item">
                                        <h6 class="dropdown-header px-0">iGaming Accounts</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/operator_logins" data-qa="navbarCdbAccountsNew">
                                        <i class="fas fa-user-lock"></i>
                                        Accounts
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/affiliate_systems" data-qa="navbarCdbAffiliateSystemsNew">
                                        <i class="fas fa-link"></i>
                                        Affiliate Systems
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/operator_affiliate_systems" data-qa="navbarCdbAffiliatePlatformsNew">
                                        <i class="fas fa-network-wired"></i>
                                        Affiliate Platforms
                                    </a>
                                    <a class="dropdown-item" routerLinkActive="active" routerLink="/company_units" data-qa="navbarCdbCompanyUnits">
                                        <i class="fas fa-building"></i>
                                        Company Units
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 col-lg">
                                <div class="list-group list-group-flush" aria-labelledby="navbarDropdown">
                                    <div class="dropdown-item">
                                        <h6 class="dropdown-header px-0">iGaming Products</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" [class.active]="isGamesActive()" routerLink="/games" data-qa="navbarCdbGames">
                                        <i class="fas fa-fw fa-gamepad"></i>
                                        Games
                                    </a>
                                    <a class="dropdown-item indented-dropdown-item mb-1" routerLinkActive="active" routerLink="/games/types" data-qa="navbarCdbGamesTypes">
                                        <i class="fas fa-fw fa-dice"></i>
                                        Games Types
                                    </a>
                                    <a class="dropdown-item indented-dropdown-item mb-1" routerLinkActive="active" routerLink="/games/manufacturers" data-qa="navbarCdbGamesProviders">
                                        <i class="fas fa-fw fa-industry"></i>
                                        Games Providers
                                    </a>
                                    <a class="dropdown-item indented-dropdown-item mb-1" routerLinkActive="active" routerLink="/games/features" data-qa="navbarCdbGamesFeatures">
                                        <i class="fas fa-fw fa-trophy"></i>
                                        Games Features
                                    </a>
                                    <a class="dropdown-item indented-dropdown-item mb-1" routerLinkActive="active" routerLink="/games/themes" data-qa="navbarCdbGamesThemes">
                                        <i class="fas fa-fw fa-star"></i>
                                        Games Themes
                                    </a>
                                    <a class="dropdown-item indented-dropdown-item mb-1" routerLinkActive="active" routerLink="/games/market-preferred-providers" data-qa="navbarCdbMarketPreferredProviders">
                                        <i class="fas fa-fw fa-ranking-star"></i>
                                        Market Preferred Providers
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/games/upcoming" data-qa="navbarCdbSlotsReleaseCalendar">
                                        <i class="fas fa-fw fa-calendar-plus"></i>
                                        Slots Release Calendar
                                    </a>
                                    <div class="dropdown-item mb-1">
                                        <h6 class="dropdown-header px-0">Payment</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/payment_providers" data-qa="navbarCdbPaymentProviders">
                                        <i class="fa fa-fw fa-bank"></i>
                                        Payment Providers
                                    </a>
                                    <a class="dropdown-item" routerLinkActive="active" routerLink="/payment_accounts" *userHasPermission="'superadmin'" data-qa="navbarCdbPaymentAccounts">
                                        <i class="fa fa-fw fa-credit-card"></i>
                                        Payment Accounts
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 col-lg-auto">
                                <div class="list-group list-group-flush" aria-labelledby="navbarDropdown">
                                    <div class="dropdown-item">
                                        <h6 class="dropdown-header px-0">General</h6>
                                    </div>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/countries" data-qa="navbarCdbCountries">
                                        <i class="fas fa-fw fa-globe-americas"></i>
                                        Countries
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/languages" data-qa="navbarCdbLanguages">
                                        <i class="fas fa-fw fa-language"></i>
                                        Languages
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/collections" data-qa="navbarCdbCollections">
                                        <i class="fa-solid fa-fw fa-layer-group"></i>
                                        Collections
                                    </a>
                                    <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/admin/verticals" data-qa="navbarCdbVerticals">
                                        <i class="fa-solid fa-fw fa-ruler-vertical"></i>
                                        Verticals
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive #websitesActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="websitesActive.isActive" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarWebsitesDropdown">
                        <i class="fas fa-globe"></i>
                        Websites
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="my-1"><a class="dropdown-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" data-qa="navbarWebsitesNew"><i class="fas fa-globe"></i> Websites</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'ga4'}" data-qa="navbarWebsitesGoogleAnalytics4New"><i class="fas fa-chart-pie"></i> Google Analytics 4</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'gtm'}" data-qa="navbarWebsitesGoogleTagManagerNew"><i class="fas fa-tags"></i> Google Tag Manager</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'managers'}" data-qa="navbarWebsitesManagersNew"><i class="fas fa-user-tie"></i> Managers</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'launch'}" data-qa="navbarWebsitesLaunchDateNew"><i class="fas fa-rocket"></i> Launch Date</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'wordpress'}" data-qa="navbarWebsitesWordPress"><i class="fa-brands fa-wordpress"></i> WordPress</a></li>
                        <li class="my-1"><a class="dropdown-item small ps-9" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/websites" [queryParams]="{layout: 'go_websites'}" data-qa="navbarWebsitesGoWebsites"><i class="fa-solid fa-person-running"></i> Go Websites</a></li>
                        <li class="my-1" *userHasPermission="'can_use_website_content_operations'"><a class="dropdown-item" routerLinkActive="active" routerLink="/content-loop" data-qa="navbarWebsitesContentLoop"><i class="fa-solid fa-arrows-spin"></i> Content Loop</a></li>
                        <li class="my-1" *userHasPermission="'can_use_website_content_operations'"><a class="dropdown-item" routerLinkActive="active" routerLink="/loop" data-qa="navbarWebsitesWeeklyLoop"><i class="fa-solid fa-calendar-check"></i> Weekly loop</a></li>
                        <li class="my-1"><a class="dropdown-item" routerLinkActive="active" routerLink="/website_pages" data-qa="navbarWebsitesPages"><i class="fas fa-file"></i> Pages</a>
                        <li class="my-1"><a class="dropdown-item" routerLinkActive="active" routerLink="/domains" data-qa="navbarWebsitesDomains"><i class="fas fa-globe"></i> Domains</a>
                        </li>
                        <li class="my-1"><a class="dropdown-item" routerLinkActive="active" routerLink="/website_scripts" data-qa="navbarWebsitesScripts"><i class="fas fa-code"></i> Website Scripts</a></li>
                        <li class="my-1"><a class="dropdown-item" routerLinkActive="active" routerLink="/page_templates" data-qa="navbarWebsitesPageTemplates"><i class="fas fa-file-lines"></i> Page Templates</a></li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive #financeActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="financeActive.isActive" href="javascript:void(0)" role="button"
                       data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarFinanceDropdown">
                        <i class="fas fa-euro-sign"></i>
                        Finance
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/finance_periods" data-qa="navbarFinancePeriods">
                                <i class="fa-solid fa-calendar-days"></i>
                                Finance Periods
                            </a>
                        </li>
                        <a class="dropdown-item mb-1" routerLinkActive="active" routerLink="/currencies" data-qa="navbarCdbCurrencies">
                            <i class="fas fa-fw fa-coins"></i>
                            Currencies
                        </a>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/currency-management" data-qa="navbarCurrencyManagement">
                                <i class="fa-solid fa-coins"></i>
                                Currency Management
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive #adminActive="routerLinkActive">
                    <a class="nav-link dropdown-toggle" [class.active]="adminActive.isActive" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarAdminDropdown">
                        <i class="fa-solid fa-user-secret"></i>
                        Admin
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="mb-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/admin/api-keys" data-qa="navbarAdminApiKeys">
                                <i class="fas fa-fw fa-key"></i>
                                API Keys
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/admin/cron_jobs" data-qa="navbarAdminCronJobs">
                                <i class="fa-solid fa-clock"></i>
                                Cron Jobs
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/admin/async_jobs" data-qa="navbarAdminAsyncJobs">
                                <i class="fa-solid fa-tasks"></i>
                                Async Jobs
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/admin/widgets" data-qa="navbarAdminWidgets">
                                <i class="fa-solid fa-bars-staggered"></i>
                                Widgets
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" routerLink="/admin/forza" data-qa="navbarAdminForza">
                                <i class="fa-solid fa-mobile-screen"></i>
                                Forza
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/users" data-qa="navbarAdminUsersNew">
                                <i class="fa fa-fw fa-user-circle"></i>
                                Users
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/groups" data-qa="navbarAdminGroupsNew">
                                <i class="fas fa-fw fa-users"></i>
                                Groups
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/freelancers" data-qa="navbarAdminFreelancersNew">
                                <i class="fa-solid fa-user-ninja"></i>
                                Freelancers
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/users/roles" data-qa="navbarAdminRoles">
                                <i class="fa fa-fw fa-user-secret"></i>
                                Roles
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/users/permissions" data-qa="navbarAdminPermissions">
                                <i class="fa fa-fw fa-unlock"></i>
                                Permissions
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/persons" data-qa="navbarAdminPeople">
                                <i class="fas fa-fw fa-users"></i>
                                People
                            </a>
                        </li>

                        <div class="dropdown-item" data-qa="navbarAdminMedia">
                            <h6 class="dropdown-header px-0">Media</h6>
                        </div>

                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/admin/media/library" data-qa="navbarAdminMediaLibrary">
                                <i class="fas fa-folder-tree"></i> Media Library
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/admin/media/media_types" data-qa="navbarAdminMediaTypes">
                                <i class="fas fa-shapes"></i>
                                Media Types
                            </a>
                        </li>
                        <li class="my-1">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/admin/media/media_categories" data-qa="navbarAdminMediaCategories">
                                <i class="fas fa-folder-open"></i>
                                Media Categories
                            </a>
                        </li>
                        <div class="dropdown-item" data-qa="navbarAdminAi" *userHasPermission="'can_use_ai_agent'">
                            <h6 class="dropdown-header px-0">AI</h6>
                        </div>

                        <li class="my-1" *userHasPermission="'can_use_ai_agent'">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/admin/ai_agent" data-qa="navbarAdminAiAgent">
                                <i class="fa-solid fa-robot"></i>
                                AI Agent
                            </a>
                        </li>
                        <div class="dropdown-item" data-qa="navbarAdminUsageSection" *ngIf="canSeeUsage">
                            <h6 class="dropdown-header px-0">Usage</h6>
                        </div>

                        <li class="my-1" *userHasPermission="'can_read_hexagon_usage'">
                            <a class="dropdown-item ps-10" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/admin/usage" data-qa="navbarAdminUsageGeneral">
                                <i class="fa-solid fa-chart-column"></i>
                                General
                            </a>
                        </li>
                        <li class="my-1" *userHasPermission="'can_read_hexagon_usage_api'">
                            <a class="dropdown-item ps-10" routerLinkActive="active" routerLink="/admin/usage/api" data-qa="navbarAdminUsageApi">
                                <i class="fa-solid fa-plug"></i>
                                API
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <div class="navbar-utility-row">
                <div class="navbar-utility-row__search">
                    <app-navbar-search data-qa="navbarSearchComponent"></app-navbar-search>
                </div>
                <div class="navbar-utility-row__actions">
                    <app-navbar-entities data-qa="navbarEntitiesComponent"></app-navbar-entities>
                    <app-navbar-suggestion-box data-qa="navbarSuggestionBoxComponent"></app-navbar-suggestion-box>
                    <div class="dropdown d-none d-xl-block" *ngIf="user">
                        <a href="javascript:void(0)" class="d-block text-gray-700 text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false" data-qa="navbarUserDropdown">
                            <app-admin-avatar [isAdmin]="user.is_admin" size="sm" [centered]="true">
                                <img src="{{ user['pic-internal'] }}" *ngIf="hasProfilePic()" (error)="handleImageError()" alt="mdo" width="32" height="32" class="rounded-circle avatar-photo">
                                <span *ngIf="!hasProfilePic()" class="user-avatar-initials user-avatar-initials--sm">{{ getUserInitials(user.first_name + ' ' + user.last_name) }}</span>
                            </app-admin-avatar>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end user-dropdown-menu" aria-labelledby="dropdownUser1">
                            <li><h6 class="dropdown-header">{{ user.first_name }} {{ user.last_name }}</h6></li>
                            <li><a class="dropdown-item" routerLink="/users/{{ user.id }}" data-qa="navbarUserProfile">My profile</a></li>
                            <li><a class="dropdown-item" routerLink="/users/{{ user.id }}/entities" data-qa="navbarUserEmailSignature">Email signature</a></li>
                            <li><a class="dropdown-item" routerLink="/users/{{ user.id }}/wordpress" data-qa="navbarUserWordPress">WordPress</a></li>
                            <li><hr class="dropdown-divider bg-secondary"></li>
                            <li>
                                <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:void(0)" (click)="switchThemeMode(); $event.stopPropagation()" data-qa="navbarUserThemeMode">
                                    <span>Mode</span>
                                    <span class="theme-switch" [class.theme-switch--light]="getThemeMode() === 'light'">
                                        <i class="fa fa-fw fa-sun"></i>
                                        <span class="theme-switch__track">
                                            <span class="theme-switch__thumb"></span>
                                        </span>
                                        <i class="fa fa-fw fa-moon"></i>
                                    </span>
                                </a>
                            </li>
                            <li><hr class="dropdown-divider bg-secondary"></li>
                            <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()" data-qa="navbarUserLogout">Logout</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>

    </div>
</nav>

<app-version-banner *ngIf="latestVersionInfo && latestVersionInfo.version !== dismissedVersion && versionToastVisible"
                     [version]="latestVersionInfo.version"
                     [versionUrl]="latestVersionInfo.versionUrl"
                     [environment]="latestVersionInfo.environment"
                     (refresh)="refreshForNewVersion()"
                     (dismiss)="dismissNewVersionBanner()">
</app-version-banner>

<ng-template #sessionExpiredModal>
    <app-auth-login [compact]="true" [showEntities]="false" [showThemeSwitcher]="false" [redirectOnLogin]="false" message="Your session has expired. Please sign in to continue." (onLoggedIn)="onSessionRestored()"></app-auth-login>
</ng-template>
